// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"y7-z","inlineTitle":"z7-z","sponsoredAdsWrapper":"A7-z","marketplaceRecosWrapper":"B7-z","brandShopTheLookWrapper":"C7-z"};